import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import { SubscriptionList, SubscriptionType } from './plans';

import { initiatePayment } from './plan-actions';
import './PlanDetails.css';

function PlanDetails() {

    const [plans, setPlans] = useState([]);
    const [isMonthly, setIsMonthly] = useState(false);
    const [isDisableSubmit, setIsDisableSubmit] = useState(false);
    const dispatch = useDispatch();

    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const storedUserId = localStorage.getItem("registeredUserId");
        if (storedUserId) {
            setUserId(storedUserId);
            console.log("Loaded userId from localStorage:", storedUserId);
        } else {
            console.warn("No registeredUserId found in localStorage!");
        }
    }, []);

    useEffect(() => {
        const list = SubscriptionList();
        const filteredList = list
            .filter(plan => plan.isMonthly === isMonthly)
            .sort((a, b) => {
                const order = [
                    SubscriptionType.StartUp,
                    SubscriptionType.EarlyGrower,
                    SubscriptionType.SoloStar,
                    SubscriptionType.Enterprise,
                    SubscriptionType.GroupGrowth,
                    SubscriptionType.MidSizeMovers
                ];
                return order.indexOf(a.subscriptionType) - order.indexOf(b.subscriptionType);
            });
        setPlans(filteredList);
    }, [isMonthly]);

    async function doPayment(id) {
        setIsDisableSubmit(true);
        const selectedPlan = plans.find(plan => plan.id === id);
        const clientReferenceId = userId;

        if (selectedPlan) {
            const paymentData = {
                price_id: selectedPlan.stripePriceId,
                trialPeriod: selectedPlan.trialPeriod,
                clientReferenceId
            };
            console.log(paymentData);
            dispatch(initiatePayment(paymentData));
        } else {
            alert('Selected plan not found.');
            setIsDisableSubmit(false);
        }
    }

    function onChange(selectedPlan) {
        setPlans(plans.map(plan => ({
            ...plan,
            isChecked: plan.id === selectedPlan.id
        })));
    }

    function setTab(isMonthlyPlan) {
        setPlans([]);
        setIsMonthly(isMonthlyPlan);
    }

    const handleEnterpriseClick = () => {
        window.location.href = 'https://calciumhealth.com/schedule-a-demo/';
    };

    const renderPlans = () => {
        return Array.isArray(plans) && plans.length > 0 ? (
            plans.map(plan => {
                const { id, planName, subscriptionType, color } = plan;

                return (
                    <div key={id} className="card-wrapper" style={{ borde: color }} >
                        <div className="card-height">
                            <div className="subscribe-card" onClick={() => onChange(plan)}>
                                <div>
                                    <div style={{ background: color, textAlign: 'center', padding: '0.01em' }}>
                                        <p style={{ fontSize: '18px', textAlign: 'center', marginTop: '0.8em', fontWeight: '600', overflow: 'hidden' }}>
                                            {planName}
                                        </p>
                                    </div>
                                    {
                                        subscriptionType === SubscriptionType.StartUp
                                            ? getStartUpPlan(isMonthly, plan, doPayment, isDisableSubmit)
                                            : subscriptionType === SubscriptionType.EarlyGrower
                                                ? getEarlyGrowerPlan(isMonthly, plan, doPayment, isDisableSubmit)
                                                : subscriptionType === SubscriptionType.SoloStar
                                                    ? getSoloStarPlan(isMonthly, plan, doPayment, isDisableSubmit)
                                                    : subscriptionType === SubscriptionType.Enterprise
                                                        ? getTrivingTeamsPlan(isMonthly, plan, doPayment, isDisableSubmit)
                                                        : subscriptionType === SubscriptionType.GroupGrowth
                                                            ? getGroupGrowthPlan(isMonthly, plan, doPayment, isDisableSubmit)
                                                            : getMidSizeMoversPlan(isMonthly, plan, doPayment, isDisableSubmit)}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
        ) : (
            <p>No plans available.</p>
        );
    };

    return (
        <div className="plan-container">
            <div className='header'>
                <Header isSignIn></Header>
            </div>
            <div className='plan-inner-wrapper'>
                <div className=" plan-select-btn">
                    <p className='plan-quote'>Select plan:</p>
                    <button onClick={() => setTab(false)} className={!isMonthly ? 'active' : ''}>Annual</button>
                    <p className='plan-quote'>/</p>
                    <button onClick={() => setTab(true)} className={isMonthly ? 'active' : ''}>Monthly</button>
                </div>
                <div className="scrollable-content">
                    {renderPlans()}
                </div>
                <div className='redirect-text'>
                    <p>Enterprise programs also available. <span onClick={handleEnterpriseClick}>Set up a call for more information.</span></p>
                </div>
            </div>
            <div className="footer">
                <Footer />
            </div>
        </div>
    );
}

function getSoloStarPlan(isMonthly, plan, doPayment, isDisableSubmit) {
    const price = plan.offerPrice ?? plan.originalPrice;
    console.log(plan.color);
    return (
        <div className='card-inner-container'>
            <div className='plan-desc'>
                <p className='subscription-details'>Free 30-day trial!</p>
                <div className='plan-price-text'>then <span>$</span><span>{plan.price}</span><span>{isMonthly ? '/month' : '/year'}!</span>
                    <p style={{ color: '#00d56f', fontWeight: 600 }}>{!isMonthly ? '10% Savings' : ''}</p>
                </div>
                <ul style={{ listStyle: 'none', padding: '0.5em 1.5em' }}>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> Ideal for solo practices</li>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> Up to 500 patients</li>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> Access health records from 99% of US hospitals</li>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> EHR interoperability with Epic, Cerner (Oracle), eCW, Athena and many more</li>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> Real-time data from hundreds of health apps, medical devices & wearables</li>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> Only <span>$499/Monthly!</span></li>
                    <li> <span style={{ color: '#2ad2c5', marginRight: '5px' }}>➤</span> One-time $499 setup fee for onboarding & assistance with configuration</li>
                </ul>
            </div>
            <div className="plan-btn">
                <button type='button' style={{ background: plan.color }} disabled={isDisableSubmit} onClick={() => doPayment(plan.id)}>
                    Start Your 30-Day Trial
                </button>
            </div>
        </div>
    );
}
function getStartUpPlan(isMonthly, plan, doPayment, isDisableSubmit) {
    const price = plan.offerPrice ?? plan.originalPrice;
    console.log(plan.color);
    return (
        <div className='card-inner-container'>
            <div className='plan-desc'>

                <div>
                    {/* <p className='subscription-details'>
                            Free 30-day trial!
                        </p> */}

                    <div
                        style={{
                            marginTop: "2em"
                        }}
                        className='plan-price-text'>
                        <span>$</span>
                        <span>{plan.price}</span>
                        <span>{isMonthly ? '/month' : '/year'}!</span>

                        {
                            !isMonthly &&
                            <p style={{ color: '#00d56f', fontWeight: 600 }}>
                                10% Savings
                            </p>
                        }
                    </div>
                </div>


                <div className='plan-description'></div>

                <ul style={{ listStyle: 'none', padding: '0.5em 1.5em' }}>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> One provider only</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Up to 50 patients</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Allows management of 1 sub-group</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Comes with 1 pathway starter pack</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Includes Group training support</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Get a 10% discount on annual plans</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> No one-time setup fee required</li>
                </ul>
            </div>
            <div className="plan-btn">
                <button type='button' style={{ background: plan.color }} disabled={isDisableSubmit} onClick={() => doPayment(plan.id)}>
                    Start
                </button>
            </div>
        </div >
    );
}
function getEarlyGrowerPlan(isMonthly, plan, doPayment, isDisableSubmit) {
    console.log(plan.color);
    return (
        <div className='card-inner-container'>
            <div className='plan-desc'>

                <div>
                    {/* <p className='subscription-details'>
                            Free 30-day trial!
                        </p> */}

                    <div
                        style={{
                            marginTop: "2em"
                        }}
                        className='plan-price-text'>
                        <span>$</span>
                        <span>{plan.price}</span>
                        <span>{isMonthly ? '/month' : '/year'}!</span>
                        {
                            !isMonthly &&
                            <p style={{ color: '#00d56f', fontWeight: 600 }}>
                                10% Savings
                            </p>
                        }

                    </div>
                </div>

                <div className='plan-description'></div>

                <ul style={{ listStyle: 'none', padding: '0.5em 1.5em' }}>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> One provider only</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Up to 125 patients</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Allows management of 1 sub-group</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Comes with 1 pathway starter pack</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Includes Group training support</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Get a 10% discount on annual plans</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> One-time $99 setup fee for onboarding & assistance with configuration</li>
                </ul>
            </div>
            <div className="plan-btn">
                <button type='button' style={{ background: plan.color }} disabled={isDisableSubmit} onClick={() => doPayment(plan.id)}>
                    Start
                </button>
            </div>
        </div>
    );
}

function getTrivingTeamsPlan(isMonthly, plan, doPayment, isDisableSubmit) {
    const price = plan.offerPrice ?? plan.originalPrice;
    return (
        <div className='card-inner-container'>
            <div className='plan-desc'>
                <p className='subscription-details'>Free 30-day trial!</p>
                <div className='plan-price-text'>then <span>$</span><span>{plan.price}</span><span>{isMonthly ? '/month' : '/year'}!</span>
                    <p style={{ color: "#00d56f", fontWeight: 600 }}>{!isMonthly ? '10% Savings' : ''}</p>
                </div>
                <ul style={{ listStyle: 'none', padding: '0.5em 1.5em' }}>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Ideal for small teams</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Up to 5 providers</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Up to 2,700 patients</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Everything in Solo Star, plus…</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Custom pathways created for you: 1/year</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Custom training for your team</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Powerful patient app co-branded with your logo/ID</li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> Only <span>$1,499/Monthly!</span></li>
                    <li> <span style={{ color: '#e3ab22', marginRight: '5px' }}>➤</span> One-time $1,499 setup fee for onboarding & assistance with configuration</li>
                </ul>
            </div>
            <div className="plan-btn">
                <button style={{ background: plan.color }} disabled={isDisableSubmit} onClick={() => doPayment(plan.id)}>
                    Start Your 30-Day Trial
                </button>
            </div>
        </div>
    );
}

function getGroupGrowthPlan(isMonthly, plan, doPayment, isDisableSubmit) {
    const price = plan.originalPrice;
    return (
        <div className='card-inner-container'>
            <div className='plan-desc'>
                <p className='subscription-details'>Free 30-day trial!</p>
                <div className='plan-price-text'>then <span>$</span> <span>{plan.price}</span><span>{isMonthly ? '/month' : '/year'}!</span>
                    <p style={{ color: "#00d56f", fontWeight: 600 }}>{!isMonthly ? '10% Savings' : ''}</p>
                </div>
                <ul style={{ listStyle: 'none', padding: '0.5em 1.5em' }}>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Ideal for growing groups</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Up to 25 providers</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Up to 145,000 patients</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Everything in Thriving Teams, plus...</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Custom pathways created for you: 2/year</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Monthly service & optimization call</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Dedicated onboarding & training for your staff</li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> Only <span>$7,499/Monthly!</span></li>
                    <li> <span style={{ color: '#36b4e7', marginRight: '5px' }}>➤</span> One-time $7,499 setup fee for onboarding & assistance with configuration</li>
                </ul>
            </div>
            <div className="plan-btn">
                <button style={{ background: plan.color }} disabled={isDisableSubmit} onClick={() => doPayment(plan.id)}>
                    Start Your 30-Day Trial
                </button>
            </div>
        </div>
    );
}

function getMidSizeMoversPlan(isMonthly, plan, doPayment, isDisableSubmit) {
    const price = plan.originalPrice;
    return (
        <div className='card-inner-container'>
            <div className='plan-desc'>
                <p className='subscription-details'>Free 30-day trial!</p>
                <div className='plan-price-text'>then <span>$</span><span>{plan.price}</span><span>{isMonthly ? '/month' : '/year'}!</span>
                    <p style={{ color: "#00d56f", fontWeight: 600 }}>{!isMonthly ? '10% Savings' : ''}</p>
                </div>
                <ul style={{ listStyle: 'none', padding: '0.5em 1.5em' }}>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Ideal for mid-sized organizations</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Up to 50 providers</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Up to 300,000 patients</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Everything in Group Growth, plus...</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Custom pathways created for you: 3/year</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Dedicated customer success agent</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Advanced training & resources for your staff</li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> Only <span>$14,999/Monthly!</span></li>
                    <li> <span style={{ color: '#e14376', marginRight: '5px' }}>➤</span> One-time $14,999 setup fee for onboarding & assistance with configuration</li>
                </ul>
            </div>
            <div className="plan-btn">
                <button className='unique-button' style={{ background: plan.color }} disabled={isDisableSubmit} onClick={() => doPayment(plan.id)}>
                    Start Your 30-Day Trial
                </button>
            </div>
        </div>
    );
}

export default PlanDetails;

